var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":!_vm.fullscreen,"color":"rgba(255, 255, 255, 0.5)","opacity":"0.9","zIndex":"5"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}})}
var staticRenderFns = []

export { render, staticRenderFns }